function generateSelectList(categories, parent, parameters, num) {

    // Get filter's form
    var filter = document.querySelector('form.filter');

    if (categories.length !== 0) {
        var select = document.createElement('select');

        select.setAttribute('name', 'category');
        select.setAttribute('data-num', num);

        var option = document.createElement('option');
        option.setAttribute('value', '');
        option.innerHTML = '-- All Categories --';
        select.appendChild(option);

        categories.forEach(function (category) {
            if (category.parentID === parent) {
                var option = document.createElement('option');
                option.setAttribute('value', category.id);
                option.innerHTML = category.title;

                // Check if the category was found in the parameters array
                if (parameters.some(function (param) {
                    return param == category.id;
                })) {

                    option.setAttribute('selected', 'selected');

                    // Add a sub list if the category is a parent
                    if (category.isParent) {

                        num += 1;
                        generateSelectList(categories, category.id, parameters, num);
                    }
                }

                select.appendChild(option);
            }
        });

        select.addEventListener('change', function () {
            // https://stackoverflow.com/questions/1085801/get-selected-value-in-dropdown-list-using-javascript
            var selected = this.options[this.selectedIndex].value;
            var listNum = this.getAttribute('data-num');
            parameters[listNum] = selected;
            parameters.splice(listNum + 1);
            num = 0;

            var lists = filter.querySelectorAll('select');
            if (lists) {
                lists.forEach(function (list) {
                    filter.removeChild(list);
                });
            }

            generateSelectList(categories, null, parameters, num);
        });

        filter.insertBefore(select, filter.firstChild);
    }

}